import React from 'react';
import type { AutomationTemplate } from '../templates.types';
import styles from './TemplatesTable.module.css';
import { TemplatesTableEmpty } from './TemplatesTableEmpty';
import { TemplatesTableRow } from './TemplatesTableRow';

interface TemplatesTableProps {
  templates: AutomationTemplate[];
}

export const TemplatesTable: React.FC<TemplatesTableProps> = ({ templates }) => {
  return (
    <>
      <div className="overflow-x-auto">
        <table className={styles.automationTemplatesTable}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {templates.map((template: AutomationTemplate) => (
              <TemplatesTableRow key={template.id} template={template} />
            ))}
          </tbody>
        </table>
      </div>

      {templates.length === 0 && <TemplatesTableEmpty />}
    </>
  );
};
